'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Search = {};

exports.__exports = Search;
